<template>
  <b-card no-body v-if="!loading && history && history.cycles && history.cycles.length" class="mb-2">
    <b-card-header class="pb-50">
      <h5 class="mb-0">
        <feather-icon icon="BookOpenIcon" class="mr-50" />
        Manuais do Franqueado
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row v-if="history.current_cycle">
        <b-col md="6" class="mb-1" v-if="history.current_cycle.sent_at">
          <small class="text-muted">Enviados em</small>
          <h5>{{ history.current_cycle.sent_at | dateTime }}</h5>
        </b-col>
        <b-col md="6" class="mb-1" v-if="history.current_cycle.receipt_confirmed_at">
          <small class="text-muted">Recebimento confirmado em</small>
          <h5>{{ history.current_cycle.receipt_confirmed_at | dateTime }}</h5>
        </b-col>
        <b-col md="6" class="mb-1" v-if="history.current_cycle.deadline_at">
          <small class="text-muted">Prazo para leitura</small>
          <h5>{{ history.current_cycle.deadline_at | onlyDate }}</h5>
        </b-col>
        <b-col md="6" class="mb-1" v-if="history.current_cycle.days_remaining !== null">
          <small class="text-muted">Dias restantes</small>
          <h5>{{ history.current_cycle.days_remaining }}</h5>
        </b-col>
        <b-col md="6" class="mb-1">
          <small class="text-muted">Status</small>
          <h5>
            <b-badge :variant="statusVariant(history.current_cycle.status)">
              {{ statusLabel(history.current_cycle.status) }}
            </b-badge>
          </h5>
        </b-col>
        <b-col md="6" class="mb-1" v-if="history.current_cycle.reading_confirmed_at">
          <small class="text-muted">Leitura confirmada em</small>
          <h5>{{ history.current_cycle.reading_confirmed_at | dateTime }}</h5>
        </b-col>
      </b-row>

      <hr />

      <p class="font-weight-bold small text-uppercase text-muted mb-1">Histórico por envio</p>

      <div v-for="cycle in history.cycles" :key="cycle.id" class="cycle-block mb-2">
        <div class="d-flex align-items-center flex-wrap mb-75" style="gap:0.5rem">
          <feather-icon icon="SendIcon" size="14" class="text-muted" />
          <strong class="small">
            Envio de {{ cycle.sent_at | dateTime }}
          </strong>
          <b-badge :variant="statusVariant(cycle.status)">
            {{ statusLabel(cycle.status) }}
          </b-badge>
          <b-badge v-if="cycle.is_current" variant="light-primary">Envio atual</b-badge>
        </div>

        <ul class="list-unstyled mb-75 pl-2">
          <li v-for="item in cycle.items" :key="item.manual_id" class="d-flex align-items-start mb-25">
            <feather-icon icon="FileTextIcon" size="14" class="text-muted mr-75 mt-25" />
            <span class="small">
              {{ item.name }} — versão {{ item.version }} —
              <span v-if="item.reading_confirmed_at" class="text-success">
                leitura confirmada em {{ item.reading_confirmed_at | dateTime }}
              </span>
              <span v-else class="text-warning">leitura pendente</span>
            </span>
          </li>
        </ul>

        <ul class="list-unstyled mb-0 pl-2">
          <li v-for="(event, i) in cycle.events" :key="i" class="d-flex align-items-start mb-25">
            <feather-icon icon="ClockIcon" size="14" class="text-muted mr-75 mt-25" />
            <span class="small text-muted">
              <strong>{{ event.date | dateTime }}</strong> — {{ event.label }}
            </span>
          </li>
        </ul>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BBadge,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import * as types from '../store/types'

const STATUS_LABELS = {
  awaiting_send: 'Aguardando envio',
  send_failed: 'Falha no envio',
  awaiting_receipt: 'Aguardando confirmação de recebimento',
  pending_reading: 'Recebido — leitura pendente',
  near_deadline: 'Prazo próximo do vencimento',
  expired: 'Prazo vencido',
  blocked: 'Acesso bloqueado',
  reading_confirmed: 'Leitura confirmada',
}

const STATUS_VARIANTS = {
  awaiting_send: 'secondary',
  send_failed: 'danger',
  awaiting_receipt: 'info',
  pending_reading: 'warning',
  near_deadline: 'warning',
  expired: 'danger',
  blocked: 'danger',
  reading_confirmed: 'success',
}

export default {
  name: 'FranchiseManualHistoryCard',
  components: {
    BCard, BCardHeader, BCardBody, BRow, BCol, BBadge,
  },
  props: {
    userId: {
      type: [Number, String],
      default: undefined,
    },
  },
  data() {
    return {
      loading: false,
      history: undefined,
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler(val) {
        if (val) this.load(val)
      },
    },
  },
  methods: {
    ...mapActions({
      getHistory: types.GET_FRANCHISE_MANUAL_HISTORY,
    }),
    load(userId) {
      this.loading = true
      this.getHistory(userId)
        .then((resp) => {
          this.history = resp.data
        })
        .catch(() => {
          this.history = undefined
        })
        .finally(() => {
          this.loading = false
        })
    },
    statusLabel(status) {
      return STATUS_LABELS[status] || status
    },
    statusVariant(status) {
      return STATUS_VARIANTS[status] || 'secondary'
    },
  },
}
</script>

<style lang="scss" scoped>
.cycle-block + .cycle-block {
  border-top: 1px solid rgba(128, 128, 128, 0.2);
  padding-top: 0.75rem;
}
</style>
